import request from '@/utils/request'

//Load Product GC Model Data
export function getHoodieJacketModelData() {
  return request({ url: 'vgethoodiejacketmodeldata', method: 'get'})
} 

export function submitHoodieDetailsApi(param) {
  return request({ url: 'vsubmithoodiedetails', method: 'post', data: param })
} 

export function getHoodieJacketOrderListApi() {
  return request({ url: 'vgethoodieorders', method: 'post', data: {'page' : 1} })
} 



export function isShowHoodiePageApi() {
  return request({ url: 'visshowhoodiepage', method: 'get'})
} 


export function getHoodieOrderDetailsApi(param) {
  return request({ url: 'vgethoodieorderdetails', method: 'post',  data: param })
} 






